__turbopack_context__.v({
  "__container": "interstitial-ad-module-scss-module__TXuO-W____container",
  "interstitial-ad": "interstitial-ad-module-scss-module__TXuO-W__interstitial-ad",
});
